import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
const forWho = ['Parejas que se aman pero que ya no se soportan en la convivencia diaria.', 'Padres agotados que sienten que solo hablan de horarios y deudas.', 'Personas que sienten que su pareja es "una carga más" en su vida.', 'Quienes ven que el contexto del país está destruyendo su hogar.'];
const notForWho = ['Parejas en situaciones de violencia física o abuso (requieren ayuda profesional inmediata).', 'Personas que ya han decidido separarse y no tienen interés en reconstruir.', 'Quienes buscan una solución mágica que no requiera sentarse a hablar 20 minutos por semana.'];
export function WhoItsForSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 md:py-28 bg-[#F0EDEB]" data-id="element-200">
      <div className="max-w-4xl mx-auto px-6" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="grid md:grid-cols-2 gap-8" data-id="element-202">
          <div className="bg-[#FFFFFF] rounded-2xl p-8 border-t-4 border-[#722F37] shadow-lg relative overflow-hidden" data-id="element-203">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#722F37]/5 rounded-bl-full" data-id="element-204"></div>
            <h3 className="text-2xl font-bold text-[#2D2D2D] mb-8 flex items-center gap-3 relative z-10" data-id="element-205">
              <CheckCircleIcon className="w-8 h-8 text-[#722F37]" data-id="element-206" />
              Para quién es:
            </h3>
            <ul className="space-y-5 relative z-10" data-id="element-207">
              {forWho.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex gap-4 items-start" data-id="element-208">
                  <CheckCircleIcon className="w-6 h-6 text-[#722F37] flex-shrink-0 mt-0.5" data-id="element-209" />
                  <span className="text-[#6B7280] leading-relaxed" data-id="element-210">{item}</span>
                </motion.li>)}
            </ul>
          </div>

          <div className="bg-[#FFFFFF] rounded-2xl p-8 border-t-4 border-[#8B1A2B] shadow-lg relative overflow-hidden" data-id="element-211">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#8B1A2B]/5 rounded-bl-full" data-id="element-212"></div>
            <h3 className="text-2xl font-bold text-[#2D2D2D] mb-8 flex items-center gap-3 relative z-10" data-id="element-213">
              <XCircleIcon className="w-8 h-8 text-[#8B1A2B]" data-id="element-214" />
              No es para:
            </h3>
            <ul className="space-y-5 relative z-10" data-id="element-215">
              {notForWho.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.5,
              delay: index * 0.1 + 0.2
            }} className="flex gap-4 items-start" data-id="element-216">
                  <XCircleIcon className="w-6 h-6 text-[#8B1A2B] flex-shrink-0 mt-0.5" data-id="element-217" />
                  <span className="text-[#6B7280] leading-relaxed" data-id="element-218">{item}</span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}